import { Card, User as UserElement } from "@heroui/react";

import { useAppContext } from "../../contexts/AppContext";

export const User = () => {
  const { user } = useAppContext();

  return user ? (
    <Card className="header-user-card canvas-overlay-card min-w-[14rem]">
      <UserElement
        name={user.user.display_name || user.user.username}
        description={user.service.instance.hostname}
        classNames={{
          name: "header-user-name",
          description: "header-user-description",
        }}
        avatarProps={{
          className: "header-user-avatar",
          showFallback: true,
          name: undefined,
          src: user.user.picture_url
        }}
        className="p-2"
      />
    </Card>
  ) : (
    <></>
  );
};